import { Inject, Injectable } from '@angular/core';
import { ConfigService } from '../../../shared/modules/my-common/services/config.service';
import { FullNamePipe } from '../../../shared/modules/ui/pipes/full-name.pipe';
import {
  AutoRepairShop,
  AutoRepairShopApi,
  MyUserFleetView,
  MyUserFleetViewApi,
  MyUserViewApi,
  Vehicle,
  VehicleApi,
} from '../../../shared/sdk';
import { DataSourceService } from 'src/app/shared/modules/my-common/services/datasource.service';
import { hAll } from 'src/app/shared/classes/utils/utils';
import { Observable, of } from 'rxjs';
import { DataSourceOptions } from 'devextreme/data/data_source';
import { map, shareReplay } from 'rxjs/operators';

@Injectable()
export class HelperService {
  autoRepairShopDso$: Observable<DataSourceOptions> = of([]);
  vehicleDso$: Observable<DataSourceOptions> = of([]);
  employeeDso$: Observable<DataSourceOptions> = of([]);
  fleetManagersDso$: Observable<DataSourceOptions>;
  fleetMechanicsDso$: Observable<DataSourceOptions>;

  requestPriorities = [
    { id: 'HIGH', name: 'High' },
    { id: 'MEDIUM', name: 'Medium' },
    { id: 'LOW', name: 'Low' },
  ];

  serviceStates = [
    { id: 'ISSUE_REPORTED', name: 'Issue Reported' },
    { id: 'SERVICE_REQUESTED', name: 'Service Requested' },
    { id: 'ACTIVE_WORK', name: 'Active Work' },
    { id: 'SERVICE_COMPLETED', name: 'Service Completed' },
  ];

  constructor(
    @Inject(ConfigService) public config: ConfigService,
    protected dss: DataSourceService,
  ) {
    this.autoRepairShopDso$ = this.buildAutoRepairShopDataSource().pipe(shareReplay(1));
    this.vehicleDso$ = this.buildVehicleDataSource().pipe(shareReplay(1));
    this.employeeDso$ = this.buildEmployeeDataSource().pipe(shareReplay(1));
    this.fleetManagersDso$ = this.employeeDso$.pipe(
      map((users: MyUserViewApi[]) => users.filter((u: any) => u._roles && u._roles.includes('FLEET_MANAGER'))),
    );
    this.fleetMechanicsDso$ = this.employeeDso$.pipe(
      map((users: MyUserViewApi[]) => users.filter((u: any) => u._roles && u._roles.includes('FLEET_MECHANIC'))),
    );
  }

  buildAutoRepairShopDataSource = () => {
    return this.dss.getApi<AutoRepairShopApi>(AutoRepairShop).find<AutoRepairShop>({ order: ['name ASC'] }, hAll);
  };

  buildVehicleDataSource = () => {
    return this.dss.getApi<VehicleApi>(Vehicle).find<Vehicle>({ order: ['internalId ASC'] });
  };

  buildEmployeeDataSource = (): Observable<DataSourceOptions> =>
    this.dss
      .getApi<MyUserFleetViewApi>(MyUserFleetView)
      .find<MyUserFleetView>({ order: ['person_firstname ASC'] }, hAll);

  displayExpr = (e: MyUserFleetView, format?): string => new FullNamePipe(this.config).transform(e, format);

  vehicleDisplayExpression = (v: Vehicle | undefined) => {
    return v
      ? `${v.internalId} - ${v.make} ${v.model}${(v.wheelchairAccessible && ' - WC BUS') || ''}${
          (v.passengerCapacity && ` - ${v.passengerCapacity} Passengers`) || ''
        }`
      : null;
  };
}
